import React, { useEffect, useMemo, useState } from 'react';
import * as styles from './talent-analytics.module.scss';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { Tabs } from 'antd';
import { TA_DETAIL_PATH, TA_TABS } from './talent-analytics.constant';
import queryString from 'query-string';
import { arrow_prev } from '../../assets/img';

const TalentAnalytics = () => {
  const location = useLocation();
  const history = useHistory();
  const [currentTab, setCurrentTab] = useState();

  const reportType = useMemo(() => {
    const { report } = queryString.parse(window.location.search);
    return report || null;
  }, [window.location.search]);

  const onChangeTab = (key) => {
    const tab = TA_TABS.find((tab) => tab.key === key);
    history.push(`${TA_DETAIL_PATH}/${tab.path}`);
  };

  useEffect(() => {
    if (location.pathname.split('/').length <= 4) {
      const tab = TA_TABS.find((tab) => location.pathname.split('/').includes(tab.path));
      setCurrentTab(tab);
    }
  }, [history, location.pathname]);

  return (
    <div className={styles.wrapper}>
      {!reportType && (
        <>
          <button className={styles.btn} onClick={() => history.push('/talent-analytics')}>
            <img src={arrow_prev} /> <span>Back to Landing Page</span>
          </button>
          <Tabs defaultActiveKey="0" activeKey={currentTab?.key} onChange={onChangeTab} items={TA_TABS} />
        </>
      )}
      <Switch>
        <Route path={`${TA_DETAIL_PATH}`} exact>
          <Redirect to={`${TA_DETAIL_PATH}/${TA_TABS[0].path}`} />
        </Route>
        {TA_TABS.map((tab) => (
          <Route key={tab.key} path={`${TA_DETAIL_PATH}/${tab.path}`} exact>
            {tab.component ? <tab.component reportType={reportType} /> : <></>}
          </Route>
        ))}
      </Switch>
    </div>
  );
};

export default TalentAnalytics;

TalentAnalytics.propTypes = {};
